export default __webpack_public_path__ + "static/media/bg_not_found.758f15a6.svg";